import { z } from 'zod/v3';

export enum AlgorithmType {
  INSERT = 'I',
  UPDATE_DIMENSION = 'UD', //Update dimension
  UPDATE_INDICATOR = 'UI', //Update indicator
}

export const zAlgorithmType = z.nativeEnum(AlgorithmType);
